import axios from "axios";
import store from '@/store'
export async function login(user) {
    return  await axios.post(`/login`,user);
}
